export const EVENT_NAME = 'af.top-notification-alert';

export interface RetirementNotificationAlertData {
  retirement?: {
    name: string;
    slug: string;
    synced: boolean;
    type: 'family' | 'foundry';
  }
}

export default class TopNotificationAlertEvent extends CustomEvent<RetirementNotificationAlertData> {
  static EVENT_NAME = EVENT_NAME;

  constructor(
    name: string,
    slug: string,
    synced: boolean,
    type: 'family' | 'foundry',
    isRetirement: boolean = false
  ) {

    const detail: RetirementNotificationAlertData = {};

    if (isRetirement) {
      detail.retirement = {
        name,
        slug,
        synced,
        type
      };
    }

    super(EVENT_NAME, {
      detail,
      bubbles: true,
      composed: true
    });
  }
}
